// Change Base Font

const fonts = {
  heading: `'M PLUS Rounded 1c', sans-serif`,
  body: `'M PLUS Rounded 1c', sans-serif`,
};

export default fonts;
